import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home-stats.png")